import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'

@Component({
  selector: 'form-search-quote-tg',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-search-quote-tg.component.html',
  styleUrl: './form-search-quote-tg.component.scss',
})
export class FormSearchQuoteTgComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search: string = ''

  listStatus: any[] = [
    { id: 0, description: 'Todos' },
    { id: 1, description: 'Aprovada' },
    { id: 2, description: 'Pendente' },
    { id: 3, description: 'Pendentes - Aguardando compras' },
    { id: 4, description: 'Análise do cliente' },
    { id: 5, description: 'Não aceita pelo cliente' },
    { id: 6, description: 'Cancelada' },
    { id: 7, description: 'Em aberto' },
  ]

  ngOnInit() {
    this.createForm()
  }

  ngOnChanges() {
    // this.updateSearch()
  }

  // updateSearch() {
  //   this.formSearch.get('search')?.setValue(this.search ?? '')
  // }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      event: [''],
      client: [''],
      subClient: [''],
      // consultantClient: [''],
      // consultantTg: [''],
      // status: [0],
      dateStart: [''],
      dateEnd: [''],
    })
  }

  sendSearch(search: boolean = true) {
    if (search && this.checkSearch()) {
      const searchModel = {
        nomeCliente: this.formSearch.get('client')!.value,
        nomeSubCliente: this.formSearch.get('subClient')!.value,
        eventoNome: this.formSearch.get('event')!.value,
        tg: this.formSearch.get('tgCode')!.value,
        dataInicio:
          this.formSearch.get('dateStart')!.value != ''
            ? moment(this.formSearch.get('dateStart')!.value).format(
                'DD/MM/YYYY',
              )
            : '',
        dataFim:
          this.formSearch.get('dateEnd')!.value != ''
            ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
            : '',
        nomeConsultor: '',
        consultorComercial: '',
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('subClient')!.setValue('')
      this.formSearch.get('event')!.setValue('')
      this.formSearch.get('tgCode')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('client')!.value.trim().length > 0 ||
      this.formSearch.get('subClient')!.value.trim().length > 0 ||
      this.formSearch.get('tgCode')!.value.trim().length > 0 ||
      this.formSearch.get('event')!.value.trim().length > 0 ||
      // this.formSearch.get('consultantClient')!.value.trim().length > 0 ||
      // this.formSearch.get('consultantTg')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value
      // this.formSearch.get('status')!.value == 0 ||
      // this.formSearch.get('status')!.value != ''
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
